import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import BlogDetailsImage from "../../components/user/Blogs Details/BlogDetailsImage";
import BlogDetailsHeading from "../../components/user/Blogs Details/BlogDetailsHeading";
import BlogDetailsContaints from "../../components/user/Blogs Details/BlogDetailsContaints";
import NavigationBanner from "../../components/common/NavigationBanner";
import Bannerimage from "../../Assets/Images/Bannerimage.png";

const SkeletonLoader = () => {
  return (
    <div className="w-full flex flex-col items-center animate-pulse">
      {/* Banner */}
      <div className="w-full h-40 bg-gray-200"></div>

      {/* Blog Image */}
      <div className="w-11/12 max-w-3xl h-64 bg-gray-200 mt-6 rounded-lg"></div>

      {/* Blog Heading */}
      <div className="w-11/12 max-w-2xl mt-6 space-y-4">
        <div className="h-6 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>

      {/* Blog Content */}
      <div className="w-11/12 max-w-3xl mt-6 space-y-3">
        <div className="h-4 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      </div>
    </div>
  );
};

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`/blogs/blog-by-id/${id}`);
        setBlog(response.data);
        setError(false);
      } catch (error) {
        console.error("Error fetching blog details:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchBlogDetails();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-start justify-center py-10">
        <SkeletonLoader />
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center px-4">
          <h3 className="text-red-600 font-semibold text-2xl mb-2">
            Blog Not Found
          </h3>
          <p className="text-gray-500 mb-6 text-sm max-w-md mx-auto">
            The blog you’re looking for doesn’t exist or has been removed.
          </p>
          <button
            onClick={() => navigate("/blogs")}
            className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md transition-colors duration-200"
          >
            Back to Blogs
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-center bg-gray-50 pb-12">
      <NavigationBanner background={Bannerimage} title={"Blog Details"} />

      {/* Blog Image */}
      <BlogDetailsImage image={blog.images?.[0]} />

      {/* Blog Heading/Meta */}
      <BlogDetailsHeading
        title={blog.title}
        author={blog.author || "Admin"}
        publishedDate={blog.publishedDate}
      />

      {/* Blog Content */}
      <div className="w-11/12 max-w-3xl">
        <BlogDetailsContaints content={blog.content} />
      </div>
    </div>
  );
};

export default BlogDetails;
